import type { DeepPartial } from '@luna/utils-ts';
import type { CurrentAccountSettingsDetailsConfig } from '@shared/products-feature-configs';

export const settingsDetails: DeepPartial<CurrentAccountSettingsDetailsConfig> = {
    displayAccountOwner: true,
    displayBalance: true,
    displayCancelledState: true,
    displayCreationDate: true,
    displayDisposable: true,
    displayOverdraftApprovedLimit: true,
    displayBIC: true,
    displayIBAN: true,
    showDetailedOverdraftBox: true,
    approvedOverdraftLabel: 'account.main.overdraft',
};
